import { gql } from "@apollo/client";

export const GET_SETTING_POLICIES = gql`
  query mySettingPolicies($settingPolicyTypes: [SettingPolicyType]) {
    mySettingPolicies(settingPolicyTypes: $settingPolicyTypes) {
      id
      updatedAt
      userRole
      type
      isUserRoleEnabled
      isPolicyTypeEnabled
      policy {
        amount
        approvalRoles
        passwordRenewPeriod
        reminderCompliances
        reminderFrequency
        categories {
          updatedAt
          categoryId
          categoryName
          amount
          currency
          isCategoryEnabled
        }
      }
    }
  }
`;

export const UPDATE_TRANSACTION_SETTING_POLICY = gql`
  mutation updateTransactionSettingPolicy(
    $id: ID!
    $categoryId: String
    $amount: Float
  ) {
    updateTransactionSettingPolicy(
      id: $id
      categoryId: $categoryId
      amount: $amount
    ) {
      id
      policy {
        categories {
          updatedAt
          amount
          categoryName
        }
      }
    }
  }
`;

export const ADD_SETTING_POLICY = gql`
  mutation addSettingPolicy(
    $settingPolicyType: SettingPolicyType!
    $userRole: RoleEnum
    $input: SettingPolicyInput
    $isForceUpdate: Boolean
  ) {
    addSettingPolicy(
      settingPolicyType: $settingPolicyType
      userRole: $userRole
      input: $input
      isForceUpdate: $isForceUpdate
    ) {
      id
    }
  }
`;

export const UPDATE_SETTING_POLICY = gql`
  mutation updateSettingPolicy(
    $id: ID!
    $input: SettingPolicyInput
    $isForceUpdate: Boolean
  ) {
    updateSettingPolicy(id: $id, input: $input, isForceUpdate: $isForceUpdate) {
      id
    }
  }
`;

export const DELETE_SETTING_POLICY = gql`
  mutation deleteSettingPolicy($id: ID!) {
    deleteSettingPolicy(id: $id) {
      id
    }
  }
`;

export const UPDATE_TRANSACTION_SETTING_POLICY_ENABLED_STATUS = gql`
  mutation updateTransactionSettingPolicyEnabledStatus(
    $updateEnabledStatusInput: TransactionSettingPolicyEnabledStatusInput!
  ) {
    updateTransactionSettingPolicyEnabledStatus(
      updateEnabledStatusInput: $updateEnabledStatusInput
    )
  }
`;
